export default __webpack_public_path__ + "static/media/bonus1.2c87c9c3.png";